"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionFooter = exports.SectionHeader = exports.SectionContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _architectMixins = require("@wealthmigrate/architect-mixins");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-FORMS [ FIELD > STYLE ] ###########################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2.1. MAKE VARIANT X .........................................................


var makeVariantX = function makeVariantX(variantX) {
  switch (variantX) {
    case 'narrow':
      return "\n        padding-left: 20%;\n        padding-right: 20%;\n        @media ".concat(_architectMixins._mixin_device.m, " {\n          padding-left:  15%;\n          padding-right: 15%;\n        }\n        @media ").concat(_architectMixins._mixin_device.xl, " {\n          padding-left:  30%;\n          padding-right: 30%;\n        }\n      ");

    case 'wide':
      return "\n        padding-left: var(--gutter-medium);\n        padding-right: var(--gutter-medium);\n      ";

    default:
      return "\n        @media ".concat(_architectMixins._mixin_device.m, " {\n          padding-left: var(--gutter-medium);\n          padding-right: var(--gutter-medium);\n        };\n        @media ").concat(_architectMixins._mixin_device.l, " {\n          padding-left:  10%;\n          padding-right: 10%;\n        };\n        @media ").concat(_architectMixins._mixin_device.xl, " {\n          padding-left:  15%;\n          padding-right: 15%;\n        };\n      ");
  }
}; // 2.1. END ....................................................................
// 2.2. MAKE VARIANT Y .........................................................


var makeVariantY = function makeVariantY(variantY) {
  switch (variantY) {
    case 'deep':
      return "\n        padding-top: var(--gutter-large);\n        padding-bottom: var(--gutter-large);\n      ";

    case 'shallow':
      return "\n        padding-top: var(--gutter);\n        padding-bottom: var(--gutter);\n      ";

    default:
      return "\n        padding-top: var(--gutter-medium);\n        padding-bottom: var(--gutter-medium);\n        @media ".concat(_architectMixins._mixin_device.s, " {\n          padding-top: var(--gutter);\n          padding-bottom: var(--gutter);\n        };\n      ");
  }
}; // 2.2. END ....................................................................
// 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. STYLES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. MAIN CONTAINER .........................................................


var SectionContainer = _styledComponents["default"].section.withConfig({
  displayName: "indexstyle__SectionContainer",
  componentId: "sc-1bhlfc6-0"
})(["", ";", ";", ";", ";", ";", ";", ";", ";", ";", ";@media ", "{padding:var(--gutter);};"], function (_ref) {
  var angle = _ref.angle;
  return angle && (0, _architectMixins._mixin_add_angle)(angle);
}, function (_ref2) {
  var scrollX = _ref2.scrollX;
  return scrollX && "overflow-x: scroll";
}, function (_ref3) {
  var scrollY = _ref3.scrollY;
  return scrollY && "overflow-y: scroll";
}, function (_ref4) {
  var variantX = _ref4.variantX;
  return variantX && makeVariantX(variantX);
}, function (_ref5) {
  var variantY = _ref5.variantY;
  return variantY && makeVariantY(variantY);
}, function (_ref6) {
  var noTop = _ref6.noTop;
  return noTop && "padding-top: 0!important";
}, function (_ref7) {
  var noBottom = _ref7.noBottom;
  return noBottom && "padding-bottom: 0!important";
}, function (_ref8) {
  var noLeft = _ref8.noLeft;
  return noLeft && "padding-left: 0!important";
}, function (_ref9) {
  var noRight = _ref9.noRight;
  return noRight && "padding-right: 0!important";
}, function (_ref10) {
  var background = _ref10.background;
  return background && (0, _architectMixins._mixin_add_paint)(background);
}, _architectMixins._mixin_device.s); // 3.1. END ....................................................................
// 3.3. SECTION HEADER ........................................................


exports.SectionContainer = SectionContainer;

var SectionHeader = _styledComponents["default"].header.withConfig({
  displayName: "indexstyle__SectionHeader",
  componentId: "sc-1bhlfc6-1"
})(["margin-bottom:var(--gutter-medium);margin-right:auto;margin-left:auto;width:50%;text-align:center!important;h2{margin:0 0 var(--gutter-small) 0;}p{", "}@media ", "{margin-bottom:var(--gutter);width:100%;};@media ", "{margin-bottom:var(--gutter);width:80%;};@media ", "{margin-bottom:var(--gutter);width:60%;};"], (0, _architectMixins._mixin_font_size)('medium'), _architectMixins._mixin_device.s, _architectMixins._mixin_device.m, _architectMixins._mixin_device.l); // 3.3. END ....................................................................
// 3.4. SECTION FOOTER .........................................................


exports.SectionHeader = SectionHeader;

var SectionFooter = _styledComponents["default"].footer.withConfig({
  displayName: "indexstyle__SectionFooter",
  componentId: "sc-1bhlfc6-2"
})(["display:flex!important;flex-direction:column;align-items:center;margin-top:var(--gutter-medium)!important;a{", "}"], (0, _architectMixins._mixin_make_button)('secondary')); // 3.4. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports.SectionFooter = SectionFooter;